import { Box } from '@factorialco/deprecated-design-system'
import { Alert, AlertTitle } from '@factorialco/f0-react/dist/experimental'
import { AlertFinancialDocumentEventFragment } from 'generated/resources/graphql'

import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import i18n from 'modules/core/lib/i18n'

import { issuedWithErrors } from 'modules/finance/components/Invoices/SaleInvoiceActivity/utils'

interface AlertIssuedWithErrorsProps {
  financialDocumentEvents: AlertFinancialDocumentEventFragment[]
  hasCreditNote: boolean
  validated: boolean
}

const AlertIssuedWithErrors = ({
  financialDocumentEvents,
  hasCreditNote,
  validated,
}: AlertIssuedWithErrorsProps) => {
  const withIssuedErrors = useUnsafeMemo(() => {
    return issuedWithErrors(validated, financialDocumentEvents)
  }, [financialDocumentEvents, validated])

  if (!withIssuedErrors || hasCreditNote) {
    return null
  }

  return (
    <Box width="full" paddingX="s20" paddingBottom="s16">
      <Alert variant="warning">
        <AlertTitle>{i18n.t('finance.sale_invoices.detail.alert_issued_with_errors')}</AlertTitle>
      </Alert>
    </Box>
  )
}

export default AlertIssuedWithErrors
